<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      title="Création de Mandat(s)">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="true"
      :has-right-col-small="true"
      :has-sticky-col-right="true">
      <div class="has-background-white is-border">
        <access-form
          :source-accounts-access="accountsAccess"
          :source-programs-access="programsAccess"
          :source-programs-access-count="programsAccessCount"
          :source-accounts-access-count="accountsAccessCount"></access-form>
      </div>
      <template slot="right-col-small">
        <div
          class="is-border"
          v-if="helperTitle || helperText">
          <div class="is-padding has-background-light--darken1">
            <div class="title is-4">
              <b>Le saviez-vous ?</b>
            </div>
          </div>
          <div class="has-text-grey is-padding">
            <!-- <p><b>{{ helperTitle }}</b></p> -->
            <p
              v-html="helperText"
              class="is-margin-top-small">
            </p>
          </div>
        </div>
      </template>
    </page-content>
  </div>
</template>

<script>
import { Access } from '@/mixins'
export default {
  name: 'AccessCreate',
  components: {
    AccessForm: () => import('./AccessForm')
  },
  mixins: [Access]
}
</script>
